






































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetDictionaryData,
  GetKepuList,
  DelKepu,
  PatchEditKepu,
  UploadFile,
  GetPaperList,
  PostPaper,
  DeletePaper,
  PatchPaper,
} from "@/request/common";
import MainHeader from "@/components/main-header.vue";
import ManageLeft from "@/components/manage-left.vue";
@Component({
  components: {
    MainHeader,
    ManageLeft,
  },
})
export default class Name extends mixins(listMixin) {
  private years: any = [];
  private ifShowEdit: any = false;
  private addType: any = "";
  private data: any[] = [];
  private edit: any = false;
  private ifShowAddLiangbiao: any = false;
  private manageType: any = "";
  private ifShowManage: any = false;
  private editData: any = {};
  private disabledDate: any = this.beginDate();
  private get user() {
    return this.$store.state.user;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private goTiqu(item: any) {
    this.$router.push({
      path: "/main/knowledge/extract",
      query: {
        type: "文献",
        id: item.id,
      },
    });
  }
  private beginDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now() - 8.64e7;
      },
    };
  }
  private openUrl(url: any) {
    window.open(url);
  }
  private editStatus(item: any) {
    let type: any = "";
    if (item.check_status === "未发布") {
      type = "已发布";
    } else if (item.check_status === "已发布") {
      type = "未发布";
    }

    PatchEditKepu(this, item.id, { check_status: type }).then((res: any) => {
      this.$message.success(type == "未发布" ? "撤回成功！" : "发布成功！");
      this.getList();
    });
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "上传中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading).then((res: any) => {
      this.editData.file = [res.data];
      this.$forceUpdate();
    });
  }
  private openAdd(item: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
      this.editData.publish_year = this.editData.publish_year.toString();
      if (this.editData.author && this.editData.author.length > 0) {
        this.editData.author = item.author.join("|");
      } else {
        this.editData.author = "";
      }
    } else {
      this.editData = {};
    }
    this.ifShowEdit = true;
  }
  private addSure() {
    if (!this.editData["name"]) {
      this.$message.warning("请输入文献名称");
      return;
    }
    if (!this.editData["author"]) {
      this.$message.warning("请输入作者");
      return;
    }
    if (!this.editData["publish_year"]) {
      this.$message.warning("请选择发表时间");
      return;
    }
    if (!this.editData["publish_journal"]) {
      this.$message.warning("请输入发表期刊");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      name: this.editData.name,
      author: this.editData.author.split("、"),
      publish_year: this.editData.publish_year,
      publish_journal: this.editData.publish_journal,
      file: this.editData.file,
    };
    if (this.editData.id) {
      PatchPaper(this, this.editData.id, params, loading).then((res: any) => {
        this.$message.success("保存成功");
        this.ifShowEdit = false;
        this.search();
      });
    } else {
      PostPaper(this, params, loading).then((res: any) => {
        this.$message.warning("保存成功");
        this.ifShowEdit = false;
        this.search();
      });
    }
  }
  private openManage(type: any) {
    this.manageType = type;
    this.ifShowManage = true;
  }
  private goEdit(item: any) {
    this.$router.push({
      path: "/main/manage/edit",
      query: {
        id: item.id,
      },
    });
  }
  private delTem(item: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DeletePaper(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        this.getList();
      });
    });
  }
  private getYears() {
    const currentYear = new Date().getFullYear();
    const years: string[] = [];

    for (let i = 0; i < 20; i++) {
      years.push((currentYear - i).toString());
    }

    this.years = years;
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 10,
        search: this.filters.search,
      },
    };
    if (this.filters["发表年份"]) {
      params.params["发表年份"] = this.filters["发表年份"];
    }
    if (this.filters["是否有全文"]) {
      params.params.is_has_file = this.filters["是否有全文"];
    }
    localStorage.setItem("literatureFilter", JSON.stringify(this.filters));
    GetPaperList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    if (localStorage.getItem("literatureFilter")) {
      this.filters = JSON.parse(
        localStorage.getItem("literatureFilter") as any
      );
    }
    this.getList();
    this.getYears();
  }
}
